export const SELECTED_STORE_ID = 'selectedStoreId';
export const PART_NUM_QUANTITY = 'partNumberQuantity';
